import getDb from "./firebase";
import {getTime} from "./time";
import {doc, onSnapshot} from 'firebase/firestore';

export function initBidForm(el, offerEl, offer, confirmAuctionBidDialog, confirmAuctionBuyNowDialog){
    const confirmAuctionBidDialogEl = confirmAuctionBidDialog.get(0);
    const confirmAuctionBuyNowDialogEl = confirmAuctionBuyNowDialog.get(0);

    const btnPlus = el.querySelector('[data-btn-bid-plus]')
    const btnMinus = el.querySelector('[data-btn-bid-minus]')
    const currentBid = el.querySelector('[data-bid-value]')
    const btnBid = el.querySelector('[data-btn-bid]')
    const btnBuyNow = offerEl.querySelector('[data-btn-buy-now]')

    btnPlus.addEventListener('click', (e) => {
        e.preventDefault();
        currentBid.value++
    })

    btnMinus.addEventListener('click', (e) => {
        e.preventDefault();
        if ((currentBid.value-1) > offer.actualPrice) {
            currentBid.value--
        }
    })

    btnBid.addEventListener('click', (e) => {
        e.preventDefault()
        confirmAuctionBidDialogEl.dataset.bidValue = currentBid.value;
        confirmAuctionBidDialogEl.dataset.offerId = offer.id;
        confirmAuctionBidDialogEl.querySelector('[data-bid-value]').textContent = currentBid.value
        confirmAuctionBidDialog.modal('show')
    })

    if (btnBuyNow) {
        btnBuyNow.addEventListener('click', (e) => {
            e.preventDefault()

            confirmAuctionBuyNowDialogEl.dataset.offerId = offer.id;
            confirmAuctionBuyNowDialogEl.querySelector('[data-bid-value]').textContent = offer.buyNowPrice;
            confirmAuctionBuyNowDialog.modal('show')
        })
    }

    offer.expiration = new Date();
}

export async function initOffer(el, confirmAuctionBidDialog, confirmAuctionBuyNowDialog) {
    const bidForm = el.querySelector('[data-auction-bid-form]');
    const bidInputEl = bidForm?.querySelector('[data-bid-value]');

    const actualPriceEl = el.querySelector('[data-auction-offer-price]')
    const endEl = el.querySelector('[data-auction-offer-end]')

    const statusEls = el.querySelectorAll('[data-offer-status]')

    const json = JSON.parse(el.dataset.auctionOffer);

    const offer = {
        _id: json.id,
        _end: new Date(json.end_at.date),
        _actualPrice: json.actual_price,
        _buyNowPrice: json.buy_now_price,
        _myBuyerId: json.my_buyer,
        _myBid: json.my_bid,
        _buyerId: json.buyer,
        _userStatus: json.user_status,
        get id() {
            return this._id;
        },
        get end() {
            return this._end;
        },
        set end(value) {
            this._end = value;
        },
        get actualPrice() {
            return this._actualPrice;
        },
        set actualPrice(value) {
            this._actualPrice = value;
            actualPriceEl.textContent = this._actualPrice;
            if (bidInputEl) {
                bidInputEl.value = this._actualPrice + 1;
            }
        },
        get buyNowPrice() {
            return this._buyNowPrice;
        },

        setClass(currentUserStatus) {
            el.classList.remove('auction-green', 'auction-red');
            if (currentUserStatus === 'top_bid' || currentUserStatus === 'offer_won') {
                el.classList.add('auction-green');
            } else if (currentUserStatus === 'low_bid' || currentUserStatus === 'offer_lost') {
                el.classList.add('auction-red');
            }
        },

        hideAllStatuses() {
            statusEls.forEach(el => el.style.display = 'none');
        },

        checkUserStatus() {
            this.hideAllStatuses();
            this.setClass(this._userStatus);
            const statusEl = el.querySelector('[data-offer-status="' + this._userStatus + '"]');
            if (statusEl) {
                statusEl.style.display = 'flex';
            }
        },

        updateFromRealtime({ end, actualPrice, buyer }) {
            this.end = end;
            this.actualPrice = actualPrice;
            this._buyerId = buyer;
            if (this._myBuyerId && this._buyerId === this._myBuyerId) {
                this._userStatus = 'top_bid';
            } else if (this._myBid !== null) {
                this._userStatus = 'low_bid';
            }
            this.checkUserStatus();
        },

        auctionEnd() {
            if (bidForm) {
                bidForm.style.display = 'none';
            }
            const btnBuyNow = el.querySelector('[data-btn-buy-now]');
            if (btnBuyNow) {
                btnBuyNow.style.display = 'none';
            }
            if (this._myBuyerId && this._buyerId === this._myBuyerId) {
                this._userStatus = 'offer_won';
            } else if (this._myBid !== null) {
                this._userStatus = 'offer_lost';
            }
            this.checkUserStatus();
        }
    }

    offer.checkUserStatus();

    if (json.status === 'offered') {
        if (bidForm) {
            initBidForm(bidForm, el, offer, confirmAuctionBidDialog, confirmAuctionBuyNowDialog)
        }

        const unsubscribe = onSnapshot(doc(await getDb(), 'auction/' + offer.id), (doc) => {
            const data = doc.data();
            if (data !== undefined) {
                offer.updateFromRealtime({
                    end: data.end.toDate(),
                    actualPrice: data.price,
                    buyer: data.buyer,
                })
            }
        });

        const interval = setInterval(() => {
            const end = offer.end;
            let left = calculateTimeLeft(end);
            if (left === null) {
                unsubscribe();
                left = 'Ukončeno';
                offer.auctionEnd();
                clearInterval(interval)
            }
            endEl.textContent = left;
        }, 250);
    }

    el.auctionOffer = offer;
}


function calculateTimeLeft(end) {
    let left = Math.round((end.getTime() - getTime().getTime()) / 1000);

    if (left < 0) {
        return null;
    }

    let hours = 0;
    let minutes = 0;
    let seconds = 0;

    if (left > 60 * 60) {
        hours = Math.floor(left / (60 * 60));
        left -= (hours * 60 * 60);
    }
    if (left > 60) {
        minutes = Math.floor(left / 60)
        left -= (minutes * 60);
    }
    seconds = left;

    let leftString = '';
    if (hours > 0) {
        leftString += hours + 'h ';
    }
    if (minutes > 0 || hours > 0) {
        leftString += minutes + 'm ';
    }
    if (seconds < 10 && leftString !== '') {
        leftString += '0' + seconds + 's';
    } else {
        leftString += seconds + 's';
    }

    return leftString;
}

